import { ContentPageId } from '@shared/models';

import { EnvName } from '../environments/environment.interface';
import { config, MigratedPages, migratedPages } from './config';

function isMigratedPage(page: ContentPageId): page is MigratedPages {
  return page in migratedPages;
}

export const getAEMPageUrl = (page: ContentPageId, env: EnvName): string | undefined => {
  if (!isMigratedPage(page)) {
    return undefined;
  }
  switch (env) {
    case 'local.external':
    case 'local.internal':
    case 'local.test.external':
    case 'local.test-2.external':
    case 'local.test-3.external':
    case 'local.test-4.external':
    case 'eng.internal':
    case 'eng.external':
    case 'test.internal':
    case 'test.external':
    case 'test-2.external':
    case 'test-3.external':
    case 'test-4.external':
    case 'e2e':
    case 'e2e-templates':
      return config[page].urls.test;
    case 'prod.internal':
    case 'prod.external':
      return config[page].urls.prod;
    default:
      // Exhaustive check
      const n: never = env;
      throw new Error('INVALID_AEM_ENVIRONMENT');
  }
};
